import React from 'react';
import { connect } from 'react-redux';

import Pagination from './Pagination';


function OutroPagination({ currentAssessment, putAssessment, questions, navigate }) {
  const urlPrefix = currentAssessment.id
    ? '/assessments/' + currentAssessment.id + '/'
    : '/assessments/new/';
  const questionsLength = Object.keys(questions).length;
  return (
    <div className="new-assessment-detail__pagination-wrapper">
      <Pagination
        prevUrl={urlPrefix + (questionsLength)}
        nextDisabled
        textDisabled
        questionNumber={questionsLength}
        totalQuestions={questionsLength}
        putAssessment={putAssessment}
        navigate={navigate}
        currentAssessmentId={currentAssessment.id}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    questions: state.sections[state.assessments.currentAssessment.section].questions,
    currentAssessment: state.assessments.currentAssessment,
  };
}

export default connect(mapStateToProps)(OutroPagination);



// WEBPACK FOOTER //
// ./src/components/features/assessment/OutroPagination.js